/**
 * Community Section Component
 *
 * Single Responsibility: Displays the community join section
 * Open/Closed: Can be extended with additional props without modifying existing code
 */

import React, { useState, FormEvent } from 'react';
import {
  typographyColors,
  backgroundColors,
  brandColors,
  spacing,
} from '@/design-system/utils';

interface CommunitySectionProps {
  onJoin?: (email: string) => void;
  className?: string;
}

export function CommunitySection({
  onJoin,
  className = '',
}: CommunitySectionProps) {
  const [email, setEmail] = useState('');

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (onJoin && email.trim()) {
      onJoin(email.trim());
      setEmail('');
    }
  };

  return (
    <div
      className={`flex flex-col items-center ${className}`}
      style={{
        padding: `${spacing[8]} ${spacing[4]}`,
        gap: spacing[6],
        backgroundColor: backgroundColors.primary,
      }}
    >
      <div
        className='flex flex-col items-center'
        style={{
          gap: spacing[2],
        }}
      >
        <h2
          className='text-3xl md:text-4xl font-bold text-center'
          style={{ color: typographyColors.primary }}
        >
          Join Our
        </h2>
        <h3
          className='text-2xl md:text-3xl font-normal text-center'
          style={{ color: typographyColors.primary }}
        >
          Community Of Explorers
        </h3>
      </div>

      <form
        onSubmit={handleSubmit}
        className='flex flex-col sm:flex-row items-center gap-3'
        style={{
          width: '100%',
          maxWidth: '500px',
        }}
      >
        <div
          className='flex-1 flex items-center gap-2 rounded-lg border px-4 py-3 w-full'
          style={{
            backgroundColor: backgroundColors.primary,
            borderColor: '#e7e5e4',
          }}
        >
          <svg
            width='20'
            height='20'
            viewBox='0 0 20 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              d='M10 10C12.7614 10 15 7.76142 15 5C15 2.23858 12.7614 0 10 0C7.23858 0 5 2.23858 5 5C5 7.76142 7.23858 10 10 10Z'
              stroke={typographyColors.secondary}
              strokeWidth='1.5'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M0 18C0 14.134 3.13401 11 7 11H13C16.866 11 20 14.134 20 18V20H0V18Z'
              stroke={typographyColors.secondary}
              strokeWidth='1.5'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>
          <input
            type='email'
            value={email}
            onChange={e => setEmail(e.target.value)}
            placeholder='Enter your email'
            className='flex-1 text-base outline-none'
            style={{
              backgroundColor: 'transparent',
              color: typographyColors.primary,
            }}
            required
          />
        </div>
        <button
          type='submit'
          className='px-6 py-3 rounded-lg font-semibold text-base whitespace-nowrap'
          style={{
            backgroundColor: brandColors.secondary,
            color: typographyColors.primary,
          }}
        >
          Join Us
        </button>
      </form>
    </div>
  );
}
